<div class="cat-listing">
  <div class="hero">
    <div class="container-large container-fluid">
      <div class="category-title">
        <ngx-skeleton-loader *ngIf=" 2 + 2 == 5" count="1" animation="progress" [theme]="{
          display: 'block',
          width: '20%',
          'border-radius': '5px',
          'background-color': '#c8c8c8',
          height: '25px'
        }"></ngx-skeleton-loader>
        <h1>
          {{this.title}}
        </h1>

      </div>
    </div>
  </div>
  <div class="container-large container-fluid">
    <div class="listing-header centered" style="background-color:white; padding:0; margin-bottom:10px;">
      <div class="listing-filter" *ngIf=" 2 + 2 == 5">
        <ul>
          <li>
            <div class="styled-select custom-select">
              <label for="filter-sort-by">
                <i class="fa fa-th-list">
                </i>
              </label>
            </div>
          </li>
          <li>
            <div class="styled-select custom-select">
              <label for="filter-added">
                <i class="fa fa-calendar">
                </i>
              </label>
            </div>
          </li>
          <li>
            <div class="styled-select custom-select">
              <label for="filter-area">
                <i class="fa fa-map-marker">
                </i>
              </label>
            </div>
          </li>
        </ul>
      </div>
      <p class="subtitle">
      </p>
    </div>
  </div>
  <div class="container-large container-fluid">
    <div class="list-container d-flex">
      <div class="column-class left-column">
        <div class="offers-list-grid skeleton-grid" *ngIf=" 2 + 2 == 5">
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
          </div>
          <div class="venue venue-skeleton">
            <ngx-skeleton-loader count="1" animation="progress" appearance="circle" loadingText="Venue Name" [theme]="{
                  width: '100%',
                  'border-radius': '0',
                  height: '180px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '4px'
                }">

            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  width: '50%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',
                  'margin-bottom': '10px',
                  'margin-top': '10px'
                }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" animation="progress" [theme]="{
                  display: 'block',
                  width: '40%',
                  'border-radius': '0',
                  height: '15px',
                  'margin-left': '0',
                  'margin-right': '0',

                  'margin-top': '8px'
                }"></ngx-skeleton-loader>
          </div>
        </div>
        <div class="opa" >

        </div>
        <div class="offers-list-grid d-flex-colum">
          <div class="offer-item d-flex" *ngFor="let offer of offers?.response">
              <div class="offer-img">
                <img src="{{offer?.filename}}" (error)="offer.filename = 'assets/images/zav-ph-d.png'">
              </div>
              <div class="offer-info d-flex-column">
                <a [attr.href]="'https://' + city + '.zavedenia.com/' + offer?.zId + '/' + returnCyrilic(offer?.zavedenie) + '/offers/' + offer?.id + '/' + returnCyrilic(offer?.label)">
                  <h2 class="offer-title ellipsis">{{offer?.label}}</h2>
                </a>
                <!-- <p class="offer-date"><i class="fa fa-calendar"></i> 20.12.2021</p> -->

                  <p class="offer-description">
                    {{offer?.descr | slice:0:150}}<a [attr.href]="'https://' + city + '.zavedenia.com/' + offer?.zId + '/' + returnCyrilic(offer?.zavedenie) + '/offers/' + offer?.id + '/' + returnCyrilic(offer?.label)" class="classic-link">&nbsp; {{word[language].seeMore}}</a>
                  </p>
                  <p class="offer-venue">{{offer?.zavedenie}}</p>

            </div>
          </div>

        </div>
      </div>

      <!-- BANNERS -->
      <div class="column-class right-column hidden-md">
        <div class="listing-ads  d-flex-column">
          <a *ngFor="let data of this.banners" href="{{data.href}}" target="_blank">
            <img src="{{data.filename}}">
          </a>
        </div>
        <div>
          <p>
            {{this.word[this.language].ad}}
          </p>
        </div>
      </div>


    </div>
  </div>
</div>
